module.exports = __webpack_public_path__ + "img/Frame_01.cb417f77.png";